// extracted by mini-css-extract-plugin
export var bodySections = "_8r-8";
export var gray = "_8r-7";
export var green = "_8r-4";
export var iconContainer = "_8r-9";
export var iconWidgetContainer = "_8r-1";
export var phoneIcon = "_8r-2";
export var red = "_8r-5";
export var statusDot = "_8r-3";
export var widgetContainer = "_8r-0";
export var yellow = "_8r-6";